/**
 * Reliable file download helper that works in all environments.
 * Appends a temporary <a> element to the DOM before clicking to ensure
 * the download triggers correctly in preview/iframe contexts.
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 200);
}

/**
 * Download a file from a URL (for images, videos, etc.)
 */
export async function downloadUrl(url, filename, headers = {}) {
  const response = await fetch(url, { headers });
  if (!response.ok) throw new Error("Download failed");
  const blob = await response.blob();
  downloadBlob(blob, filename);
}
